import React from 'react';

import { ResolveNickName } from 'api/nickResolveApi';
import { ViewUserAchievement } from 'components/achievementAssets';
import ApplicationEvents from 'components/applicationEvents';
import { CredentialsIcon } from 'components/credentialsIcon';
import { DialogHolder } from 'components/dialogHolder';
import { EventLogController } from 'components/eventLog';
import G_marketConfigStorage from 'components/globalMarketConfigStorage';
import { spawnThemeTestModal } from 'components/themeTestDialog';
import { _I_ } from 'components/translate';
import { spawnUserSettingsModal } from 'components/userSettingsDialog';
import { LogStream } from 'generics/common';
import {
  Navbar,
  NavbarNav,
  NavbarNavDropdown,
  NavbarNavDropdownAction, NavbarNavLink
} from 'generics/navbar';
import { getStartArgs } from 'generics/queryArgs.js';
import { SettingsInjections } from 'generics/settingsInjections';
import { setUserHash } from 'generics/utils';
import ViewLegalFooter from "./legalFooter";

LogStream.enable("ACHIEVEMENTAPP");

const handleRelogin = () => ApplicationEvents.emit_async("auth.goToRelogin", "AchievementApp.Navbar relogin link");

class AchievementApp extends React.Component {
  constructor(props) {
    super(props);

    this.setCurrentUserById = (userid, nick) => this.setCurrentUser(userid, nick);

    const { credentials } = this.props;
    const { userId, nick } = credentials;

    this.state = {
      "page": "achievement",
      "currentAsset": null,
      "currentUser": userId,
      "currentNick": nick
    };

  }

  componentDidMount() {
    ApplicationEvents.on("achievement.setCurrentUserById", this.setCurrentUserById);
    ApplicationEvents.emit_async("achievement.loadAchievements");
    this.updateUserIdArg();
    this.updateAppIdArg();
  }

  updateUserIdArg() {
    const { nick } = getStartArgs();

    const { credentials } = this.props;
    const userNick = credentials.nick;

    if (nick && this.state.currentNick != nick) {
      ResolveNickName(nick).then((resolved) => {
        if (!resolved) {
          setUserHash(userNick);
          return;
        }

        ApplicationEvents.emit_async("achievement.setCurrentUserById", resolved, nick);
      });
    }
    else
      setUserHash(userNick);
  }

  updateAppIdArg() {
    let { app } = getStartArgs();
    app = parseInt(app);

    if (app)
      ApplicationEvents.emit_async("achievement.setCurrentAppId", app);
  }

  componentWillUnmount() {
    ApplicationEvents.off("achievement.setCurrentUserById", this.setCurrentUserById);
  }

  setCurrentUser(uid, unick) {
    const { credentials } = this.props;
    const { userId, nick } = credentials;

    LogStream("ACHIEVEMENTAPP").info("setCurrentUserById -> ", uid, unick);

    if (!unick) {
      setUserHash(nick);
      this.setState({ "currentUser": userId, "currentNick": nick });
      return;
    }

    setUserHash(unick);
    this.setState({ "currentUser": uid, "currentNick": unick });
    return;
  }

  setPage(page) {
    this.setState({ "page": page, "currentAsset": null, "currentUser": null });
  }


  onShowThemeTestModal() {
    spawnThemeTestModal();
  }


  renderAppNavbar() {
    const currentPage = this.state.page;
    const { currentUser, currentNick } = this.state;
    const { credentials } = this.props;
    const { steamAppId, steamId, userId } = credentials;
    const steamArgs = (steamAppId && steamId) ? `?app_id=${steamAppId}&steam_id=${steamId}` : "";
    const storeHost = process.env.REACT_APP_STORE_HOST;
    const profileHref = `${storeHost}/user.php${steamArgs}`;
    const isCurrentUser = !currentUser || userId == currentUser;
    return (
      <Navbar>
        <NavbarNav>
          <NavbarNavLink active={currentPage == "achievement" && isCurrentUser}
            onClick={() => this.setCurrentUser(null)}  >
            {_I_("AchievementApp.Navbar.achievement")}
          </NavbarNavLink>

          <NavbarNavLink active={currentPage == "achievement" && !!currentUser}
            hidden={isCurrentUser}>
            {_I_("AchievementApp.Navbar.userAchievement")} {currentNick}
          </NavbarNavLink>

          <NavbarNavDropdown
            caption={(
              <CredentialsIcon creds={credentials} />
            )}  >

            <NavbarNavDropdownAction onClick={spawnUserSettingsModal}  >
              {_I_("AchievementApp.Navbar.settingsLink")}</NavbarNavDropdownAction>

            <NavbarNavDropdownAction href={profileHref} newtab  >
              {_I_("AchievementApp.Navbar.profileLink")}</NavbarNavDropdownAction>

            <NavbarNavDropdownAction onClick={handleRelogin}  >
              {_I_("AchievementApp.Navbar.reloginLink")}</NavbarNavDropdownAction>

            <NavbarNavDropdownAction onClick={() => this.onShowThemeTestModal()}
              hidden={!this.props.siteSettings.enableThemeTests}  >
              Theme Testing</NavbarNavDropdownAction>

          </NavbarNavDropdown>

        </NavbarNav>
      </Navbar>
    );
  }

  renderAchievement() {
    const hiddenPage = (this.state.currentAsset ||
      (this.state.page != "achievement")) ? "hidden" : "";

    const { currentUser, currentNick } = this.state;
    const { credentials } = this.props;
    const { userId, nick } = credentials;

    return (
      <div className={hiddenPage}>
        <ViewUserAchievement appIds={this.props.appIds}
          userid={currentUser}
          usernick={nick}
          currentnick={currentNick}
          loggedUser={userId}
        />
      </div>
    );
  }

  render() {
    const appMode = SettingsInjections.getMode();

    const logoClass = appMode == 'pixstorm' ? 'px-logo' : 'gaijin-logo';

    return (
      <div id="appBody">
        <div className="appScreen rubber rubber--bordered">
          <div className="header">
            <div className="descriptor">
              <a className="h1 descriptor__title" href="/"> <span className="logo-title">{_I_("AchievementApp.Navbar.pageTitlePrew")}</span><span className={logoClass}></span> <span className="logo-title">{_I_("AchievementApp.Navbar.pageTitle")}</span></a>
            </div>
          </div>
          <div className="personal-account">
            <div className="wrapper">
              {this.renderAppNavbar()}
              {this.renderAchievement()}
            </div>
          </div>
          <ViewLegalFooter />
        </div>
      </div>
    );
  }

}


export class MarketConfigLoader extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      appIds: null
    };
  }

  loadAppIds() {
    return G_marketConfigStorage.load(
    ).catch((error) => {
      console.warn("loadAppIds", error);
    });
  }

  componentDidMount() {

    Promise.all([
      this.loadAppIds()
    ]).then(() => {
      this.setState({ appIds: G_marketConfigStorage.getAppIdList() });
    }).catch((error) => {
      console.warn("MarketConfigLoader", error);
    });
  }


  componentWillUnmount() {
  }


  render() {
    if (!this.state.appIds)
      return null;

    return (
      <div>
        <AchievementApp
          credentials={this.props.credentials}
          siteSettings={this.props.siteSettings}
          appIds={this.state.appIds}
        />

        <DialogHolder />
        <EventLogController
          token={(this.props.credentials || {}).token}
          devMode={this.props.devMode}
        />
      </div>
    );
  }

}